import { NavLink } from "react-router-dom";
import { formatAssetPrice } from "../../api/assetApi";

function plainText(html) {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

export default function AssetCard({
  asset,
  actionLabel = "View Details",
  actionTo = "/consult",
  online = false,
  className = "",
}) {
  return (
    <article
      className={`guided-master-card p-[14px] rounded-xl second-bg d-flex flex-column ${className}`}
    >
      <div className="position-relative">
        {asset.image ? (
          <img
            src={asset.image}
            alt={asset.title}
            className="guided-master-card__image"
          />
        ) : (
          <div className="guided-master-card__no-image">No image</div>
        )}
        {online && (
          <span className="position-absolute bottom-0 end-0 bg-dark text-white px-2 py-1 text-[12px]">
            online
          </span>
        )}
      </div>

      <div className="py-3 d-flex flex-column flex-grow-1">
        <div className="d-flex justify-content-between gap-3 mb-2">
          <h3 className="text-lora text-[20px] font-semibold mb-0">
            {asset.title}
          </h3>
          {asset.price != null && (
            <div className="text-end flex-shrink-0">
              <strong className="text-[20px]">₹{formatAssetPrice(asset.price)}</strong>
              <small className="d-block">Per Session</small>
            </div>
          )}
        </div>
        <p className="text-[14px] mb-1">{asset.category}</p>
        {asset.subCategory && (
          <p className="text-[14px] mb-1">{asset.subCategory}</p>
        )}
        {asset.description && (
          <p className="text-[14px] light-color mb-3">
            {plainText(asset.description).slice(0, 110)}
          </p>
        )}
        <NavLink
          to={actionTo}
          state={asset}
          className="first-btn text-center no-underline mt-auto"
        >
          {actionLabel}
        </NavLink>
      </div>
    </article>
  );
}
